import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";
import reportWebVitals from './reportWebVitals';

const auth0Config = {
  authority: `https://${process.env.REACT_APP_AUTH0_DOMAIN}`,
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid profile email",
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  
  // Auth0 specific settings
  automaticSilentRenew: true,
  loadUserInfo: true,
  
  // Metadata for OIDC client
  metadata: {
    issuer: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/`,
    authorization_endpoint: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/authorize`,
    token_endpoint: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/oauth/token`,
    userinfo_endpoint: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/userinfo`,
    jwks_uri: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/.well-known/jwks.json`,
    end_session_endpoint: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/v2/logout?returnTo=${encodeURIComponent(window.location.origin)}&client_id=${process.env.REACT_APP_AUTH0_CLIENT_ID}`
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider {...auth0Config}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
